"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCountString = void 0;
/**
 *
 * @param count - количество объектов
 * @param first - строка для одного объекта, например, "день"
 * @param second - строка для двух объектов, например, "дня"
 * @param more - строка для множества объектов, например, "дней"
 */
function getCountString(count, first, second, more) {
    if (count === 1 || (count !== 11 && count % 10 === 1)) {
        return first;
    }
    else if ((count >= 2 && count <= 4) ||
        (count !== 12 && count !== 13 && count !== 14 && count % 10 >= 2 && count % 10 <= 4)) {
        return second;
    }
    else {
        return more;
    }
}
exports.getCountString = getCountString;
//# sourceMappingURL=index.js.map